import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=9823d9e4&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"
import style0 from "./MyAccount.vue?vue&type=style&index=0&id=9823d9e4&prod&lang=css"
import style1 from "./MyAccount.vue?vue&type=style&index=1&id=9823d9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9823d9e4",
  null
  
)

export default component.exports